export const environment = {
  envLabel: 'DEV',
  production: false,
  BORROMEO_API: 'https://app.borromeo.mx/api/mutua-borromeo',
  ENCRYPT_KEY: 'e3743ccb79b2b53be99f927de2a74fb89cd2a5107121c91d09b741142bf32e8f',
  ENCRYPT_IV: '9e387b272faaef9be8d1d622e922cd6a'
};
